import { useMutation } from "@tanstack/react-query";
import { CreateTeamRequest } from "@/Stub/V1";
import { processValidationErrors } from "@/Util/Api/processValidationErrors";
import { TeamsApiClient } from "@/Service/Api/V1/ApiClients/TeamsApiClient";

export const useCreateTeam = () => useMutation({
    mutationFn: async (data: CreateTeamRequest) => {
        try {
            return await TeamsApiClient.createTeam(data);
        } catch (error) {
            await processValidationErrors(error);
            throw error;
        }
    }
});